module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM12 24H8v-4l10-10 4 4-10 10zm13.446-13.446L24 12l-4-4 1.446-1.446a1.998 1.998 0 0 1 2.828 0l1.172 1.172c.78.782.78 2.048 0 2.828z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/compose-1.js
// module id = 1084
// module chunks = 14